import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapAppName = React.lazy(function () {
    return import('../../bootstrap-components/components/BTAppName');
});
var bootStrapAppName = function (props) {
    return React.createElement(BootStrapAppName, __assign({}, props));
};
var AppName = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapAppName(props);
            break;
        default:
            componentToDisplay = bootStrapAppName(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
AppName.defaultProps = {
    ioTheme: themes[0]
};
export default React.memo(AppName);
//# sourceMappingURL=AppName.js.map